import { render, staticRenderFns } from "./CompanyOrganization.vue?vue&type=template&id=26f72142&scoped=true&"
import script from "./CompanyOrganization.vue?vue&type=script&lang=js&"
export * from "./CompanyOrganization.vue?vue&type=script&lang=js&"
import style0 from "./CompanyOrganization.vue?vue&type=style&index=0&id=26f72142&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f72142",
  null
  
)

export default component.exports